import _toConsumableArray from "/home/circleci/project/website/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { curry, slice, size } from 'lodash/fp';
var insertIntoArray = curry(function (index, element, array) {
  return [].concat(_toConsumableArray(slice(0, index, array)), [element], _toConsumableArray(slice(index, size(array), array)));
});
export default insertIntoArray;